/**
 * Vehicle fuel type values
 */
export enum VehicleFuelTypeEnum {
	PETROL = 'petrol',
	GAS = 'gas',
	HYBRID = 'hybrid',
	PLUG_IN_HYBRID = 'plug_in_hybrid',
	ELECTRIC = 'electric',
}
